import { render, staticRenderFns } from "./SegItineraries.vue?vue&type=template&id=20fe3c1b&"
import script from "./SegItineraries.vue?vue&type=script&lang=js&"
export * from "./SegItineraries.vue?vue&type=script&lang=js&"
import style0 from "./SegItineraries.vue?vue&type=style&index=0&id=20fe3c1b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports